import React, { useEffect, useState } from 'react';
import {
  FormGroup,
  Input, Label,
  Modal, ModalBody, ModalFooter, ModalHeader,
} from 'reactstrap';
import { t, translate } from 'react-switch-lang';
import { observer } from 'mobx-react';
import { toast } from 'react-toastify';
import PhoneInput2 from 'react-phone-input-2';
import PhoneInput from 'react-phone-number-input';
import StandardButton from '../../../components/buttons/Base/StandardButton';
import chatStorage from '../../../pages/Chat/chatStorage';
import { requestGet, requestPost } from '../../../services/real.backend';

import 'react-phone-number-input/style.css';

import 'react-phone-input-2/lib/style.css';
import authStorage from '../../../storages/mobx/authStorage';
import settingsStorage from '../../../storages/mobx/settingsStorage';

function ModalManagerInviteUser({
  t,
}) {
  const linkText = 'Добрый день. Это Школа «Реабилитолог». Мы меняем канал связи в вайбере. Чтобы продолжить дальнейшее общение с Вашим персональным консультантом, перейдите пожалуйста по ссылке. ';
  // const linkText = '';
  const [phone, setPhone] = useState('');
  const [contactID, setContactID] = useState(null);
  const [allowToSend, setAllowToSend] = useState(false);
  const [textForEsputnikViber, setTextForEsputnikViber] = useState(false);
  const [editInvitation, setEditInvitationMode] = useState(false);
  const [isInvitationChanged, setInvitationChangeStatus] = useState(false);

  useEffect(() => {
    requestGet('/api/settings/invitationText')
      .then((data) => setTextForEsputnikViber(data.invitationText));
  }, []);
  const closeWindow = () => {
    setContactID(null);
    setPhone(null);
    chatStorage.toggleManagerInviteLinkDialog();
  };
  const saveContact = () => {
    chatStorage
      .savePhone(phone)
      .then((resp) => {
        setContactID(resp.contactID);
        setAllowToSend(true);
      })
      .catch((e) => {
        setContactID(null);
        setAllowToSend(false);
        toast.error(t(e.message));
      });
  };

  const sendInvitation = () => {
    chatStorage
      .sendInvitation(phone, contactID, isInvitationChanged ? textForEsputnikViber : null)
      .then((result) => {
        toast.success(t('Success'));
        closeWindow();
      })
      .catch((e) => {
        toast.error(t(e.message));
      });
  };
  return (
    <Modal isOpen={chatStorage.managerInviteLinkDialogOpened} toggle={closeWindow}>
      <ModalHeader toggle={closeWindow}>
        {t('chat.sendInvitation')}
      </ModalHeader>
      <ModalBody>
        {t('Phone')}
        <PhoneInput2
          containerClass="mb-2"
          inputClass="form-control mb-2 w-100"
          country="ua"
          value={phone}
          onChange={setPhone}
        />
        {allowToSend && (
        <div className="w-100">
          {editInvitation && (
          <Input
            id="hasText"
            type="textarea"
            className=" mx-0 position-relative"
            value={textForEsputnikViber}
            onChange={(e) => {
              setTextForEsputnikViber(e.target.value);
              setInvitationChangeStatus(true);
            }}
          />
          )}
          <StandardButton
            onClick={() => setEditInvitationMode(!editInvitation)}
            id="invitationEditToggle"
          >
            {editInvitation ? t('chat.closeInvitationEditor') : t('chat.openInvitationEditor')}
          </StandardButton>
        </div>
        )}
      </ModalBody>
      <ModalFooter>
        <div className="button-group-mb-sm">
          <StandardButton className="form-control" onClick={() => (allowToSend ? sendInvitation() : saveContact())} id="addPhone">{allowToSend ? t('chat.Send') : t('chat.Check')}</StandardButton>
          {/* <StandardButton */}
          {/*  className="btn-secondary" */}
          {/*  onClick={closeWindow} */}
          {/* > */}
          {/*  {t('Cancel')} */}
          {/* </StandardButton> */}
        </div>
      </ModalFooter>
    </Modal>
  );
}

ModalManagerInviteUser.propTypes = {};

export default translate(observer(ModalManagerInviteUser));
